







export default {
  name: 'AppTabs.vue',
};
